import { configureStore } from '@reduxjs/toolkit';
import { navigationReducer } from 'features/Navigation';
import { stepReducer } from 'features/StepInfo';
import { plotStepsReducer } from 'widgets/PlotSteps/model/slice/plotStepsSlice';
import { StateSchema } from './StateSchema';
import { servicesReducer } from 'features/Services';
import { userReducer } from 'features/User';

export function createReduxStore(initialState?: StateSchema) {
    return configureStore<StateSchema>({
        reducer: {
            navigation: navigationReducer,
            stepInfo: stepReducer,
            services: servicesReducer,
            user: userReducer,
            plotSteps: plotStepsReducer,
        },
        devTools: __IS_DEV__,
        preloadedState: initialState,
    });
}
